import React from "react";
import { Box, MenuItem, Pagination, Stack, TextField, Typography } from "@mui/material";
import { useIntl } from "react-intl";

export const GESTION_PAGE_SIZE_OPTIONS = [10, 12, 25, 50, 100];

const GestionListPagination = ({
  page,
  totalPages,
  pageSize,
  totalResults,
  onPageChange,
  onPageSizeChange,
  disabled = false,
}) => {
  const intl = useIntl();

  if (totalResults === 0) {
    return null;
  }

  const from = page * pageSize + 1;
  const to = Math.min(totalResults, (page + 1) * pageSize);

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "stretch", sm: "center" }}
      justifyContent="space-between"
      spacing={2}
      sx={{ mt: 2, mb: 1 }}
    >
      <Typography variant="body2" color="text.secondary">
        {intl.formatMessage({ id: "gestion.pagination.range" }, { from, to, total: totalResults })}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap" useFlexGap>
        <TextField
          select
          size="small"
          label={intl.formatMessage({ id: "gestion.pagination.pageSize" })}
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
          disabled={disabled}
          sx={{ minWidth: 140 }}
        >
          {GESTION_PAGE_SIZE_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>

        <Pagination
          count={Math.max(totalPages, 1)}
          page={page + 1}
          onChange={(_, value) => onPageChange(value - 1)}
          color="primary"
          shape="rounded"
          siblingCount={1}
          boundaryCount={1}
          disabled={disabled}
        />
      </Stack>
    </Stack>
  );
};

export default GestionListPagination;
